import {
  EngagementCommercialListGetDeliveryInfoResponse,
  EngagementDeliveryInfoResponseDto,
  EngagementProductWithDeliveryInfoResponseDto,
  IDeliveryInfoResponseDto,
  ListDeliveryInfoResponseDto,
  ListOrderType,
  ProductWithDeliveryInfoResponseDto,
} from '@epicuro-next/data/engagement/engagement-models';
import { PulseOrderType } from 'models-common';

import { engagementOrderTypeMapper } from '../engagement-order-type-mapper/engagement-order-type-mapper';

export function engagementDeliveryInfoMapper({
  currency,
  products,
}: ListDeliveryInfoResponseDto): EngagementCommercialListGetDeliveryInfoResponse {
  const transformProducts = mapDeliveryInfoProducts(products);

  return { currency, products: transformProducts };
}

function mapDeliveryInfoProducts(
  products: ProductWithDeliveryInfoResponseDto[],
): EngagementProductWithDeliveryInfoResponseDto[] {
  return products.map(({ deliveryInfo, ...payload }) => ({
    ...payload,
    deliveryInfo: mapProductsDeliveryInfo(deliveryInfo),
  }));
}

function mapProductsDeliveryInfo(
  deliveryInfo: IDeliveryInfoResponseDto[],
): EngagementDeliveryInfoResponseDto[] {
  return deliveryInfo.map((info) => {
    const {
      productId: productSizeId,
      totalRequestedQuantity: quantity,
      requestedDeliveryDate: deliveryDate,
      orderType,
      displayDateFrom,
      ...payload
    } = info;

    const mapOrderType =
      orderType === PulseOrderType.Any
        ? ListOrderType.Future
        : engagementOrderTypeMapper(orderType);

    return {
      ...payload,
      productSizeId,
      quantity,
      deliveryDate,
      orderType: mapOrderType,
    };
  });
}
